module.exports = __webpack_public_path__ + "static/media/app-mockup.92f0fc59.png";